<template>
  <div v-if="!$auth.loading && $auth.isAuthenticated">
    <ul>
      <li v-for="item in items" :key="item.id" class="service-listings">
        <Service :item="item" @active="updateActive" @screen="updateScreen" />
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
ul {
  padding: 0;
}
ul li.service-listings {
  list-style: none;
  border: solid 1px #dde5e7;
  border-radius: 0.3em;
  padding: 5px;
  margin: 5px;
}
</style>

<script>
/* eslint-disable */
import Service from '@/components/Service.vue';

export default {
  components: {
    Service,
  },
  props: {
    items: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {
    updateScreen(newScreen) {
      this.$emit('screen', newScreen);
    },
    updateActive(params) {
      this.$emit('active', params);
    },
  },
  computed: {},
};
</script>
